const fallbackCopyTextToClipboard = (obj: any, text: string) => {
    let textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;

    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
    return 0
}

const copyTextToClipboard = (obj: any, text: string) => {
    if (!navigator.clipboard) {
        return fallbackCopyTextToClipboard(obj, text);
    }
    navigator.clipboard.writeText(text).then(function() {
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

export default copyTextToClipboard
